var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoundOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: "round-outline_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.333a2.667 2.667 0 100 5.334 2.667 2.667 0 000-5.334zM8.667 12a3.333 3.333 0 116.666 0 3.333 3.333 0 01-6.666 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDkuMzMzYTIuNjY3IDIuNjY3IDAgMTAwIDUuMzM0IDIuNjY3IDIuNjY3IDAgMDAwLTUuMzM0ek04LjY2NyAxMmEzLjMzMyAzLjMzMyAwIDExNi42NjYgMCAzLjMzMyAzLjMzMyAwIDAxLTYuNjY2IDB6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
export { SvgRoundOutline as ReactComponent };